module.exports = __webpack_public_path__ + "static/media/Geodude_gaussian2.ec128c53.png";